module.exports = __webpack_public_path__ + "00f092fbda606edb15e6322abee2a564.png";